<template>
  <section class="lead-form-popup">
    <div class="form-popup-content br-12">
      <div data-v-5ee4643a="" class="close-popup" @click="$emit('close')">
        <svg
          data-v-5ee4643a=""
          xmlns="http://www.w3.org/2000/svg"
          width="15.314"
          height="15.314"
          viewBox="0 0 15.314 15.314"
        >
          <g
            data-v-5ee4643a=""
            id="Group_2110"
            data-name="Group 2110"
            transform="translate(-31.343 15.657)"
          >
            <path
              data-v-5ee4643a=""
              id="Union_10"
              data-name="Union 10"
              d="M11.9,14.729,7.657,10.486,3.415,14.729A2,2,0,0,1,.586,11.9L4.829,7.657.586,3.415A2,2,0,0,1,3.415.586L7.657,4.829,11.9.586a2,2,0,0,1,2.829,2.829L10.486,7.657,14.729,11.9A2,2,0,1,1,11.9,14.729Z"
              transform="translate(31.343 -15.657)"
              fill="#444958"
            ></path>
          </g>
        </svg>
      </div>

      <div class="lead-form-container">
          <h3 class="other-title">{{ $fn.tr("პარტნიორი დეველოპერების ფორმა") }}</h3>

          <el-form
            v-if="formStatus=='show-form'"
            action
            class="member-form flex-box column"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
          >
            <el-form-item
              for="name"
              class="flex-box column font-12 noto-semibold"
              prop="name"
            >
              {{ $fn.tr("სახელი, გვარი") }}
              <el-input
                type="text"
                name="name"
                :placeholder="$fn.tr('სახელი, გვარი')"
                v-model="ruleForm.name"
              ></el-input>
            </el-form-item>

            <el-form-item
              for="phone"
              class="flex-box column font-12 noto-semibold"
              prop="phone"
            >
              {{ $fn.tr("მობილურის ნომერი") }}
              <el-input
                type="number"
                name="phone"
                :placeholder="$fn.tr('მობილურის ნომერი')"
                v-model="ruleForm.phone"
              ></el-input>
            </el-form-item>

            <div class="form-end flex-box">
              <el-button class="btn sub white ml-0" type="primary" @click="submitForm()" >{{ $fn.tr("Send") }}</el-button>
            </div>
          </el-form>

          <div class="success-msg br-12" v-show="formStatus=='show-thank-text'">
            <h5 class="noto-bold font-34">{{ $fn.tr("Thank you!") }}</h5>

            <p class="text">
              {{_.get( $store.state.current_content, 'primary.0.thanks_text' )}}
            </p>

            <button class="reset-btn btn white" @click="resetForm">{{ $fn.tr("Reset") }}</button>
          </div>
      </div>
    </div>
  </section>
</template>

<script>
import DynamicForm from "@/components/DynamicForm.vue";

export default {
  props: {
    formName: {
      type: String,
    },
  },
  components: {
    DynamicForm,
  },
  data() {
    return {
      formStatus: 'show-form',
      ruleForm: {
        name: "",
        phone: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$fn.tr("მიუთითე სახელი, გვარი"),
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$fn.tr("მიუთითე ნომერი"),
            trigger: "blur",
          },
        ],
      },
    }
  },
  methods: {
    async sendForm(payload) {
      await this.$fn.postData("main/saveLeadForm", payload);

      this.formStatus = 'show-thank-text';
    },
    async submitForm(formName) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let req = {
            formData: {
              ...this.ruleForm,
            },
            formType: "partner-developers",
          };

          this.sendForm(req);
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleForm = {};
      this.formStatus = 'show-form';
      this.selectedBranch = 0;
      this.selectedCity = 0;
      this.selectedRegion = 0;
    },
  },
};
</script>

<style>
.lead-form-popup {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(35, 39, 48, 0.6);
  width: 100%;
  height: 100%;
  right: 0;
  bottom: 0;
  z-index: 3000;
  opacity: 0;
  pointer-events: none;
  -webkit-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
}
.lead-form-popup.show {
  opacity: 1;
  pointer-events: all;
}
.form-popup-content {
  position: absolute;
  width: 530px;
  max-height: calc(100% - 40px);
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: relative;
  background: #e2dfd8;
  padding: 25px 32px 41px 29px;
  border: 2px solid #bcbec0;
  padding: 30px;
  -webkit-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
  overflow: hidden;
}
.lead-form {
  backface-visibility: hidden;
  margin-top: 21px;
}
.lead-form-container {
  display: flex;
  flex-direction: column;
  height: calc(100% - 25px);
  overflow: auto;
}
.lead-form-container::-webkit-scrollbar {
  width: 4px;
  border-radius: 4px;
}

.lead-form-container::-webkit-scrollbar-thumb {
  background-color: #bcbec0;
  border-radius: 4px;
}
.lead-form {
  height: 100%;
}
.lead-form-container h3 {
  background-position: bottom;
  background-size: 22px 1px;
  background-repeat: repeat-x;
  margin-bottom: 60px;
}
.lead-form .el-input__inner,
.lead-form textarea {
  border-radius: 6px;
  padding-left: 15px;
  padding-right: 15px;
  border: 1px solid #bcbec0;
  box-shadow: none;
  margin-top: 7px;
}
.lead-form-container .el-input__inner::placeholder {
  color: #444958;
  transition: 0.3s;
}
.lead-form .el-input__inner:focus::placeholder {
  opacity: 0;
}
.lead-form-container .el-form-item.is-error .el-input__inner,
.lead-form-container .el-form-item.is-error .el-input__inner:focus,
.lead-form-container .el-form-item.is-error .el-textarea__inner,
.lead-form-container .el-form-item.is-error .el-textarea__inner:focus,
.lead-form-container .el-message-box__input input.invalid,
.lead-form-container .el-message-box__input input.invalid:focus {
  border-color: #d0aa67;
  backface-visibility: hidden;
}
.lead-form-container .el-input__inner {
  background-color: #eeece8;
}
.lead-form-container .el-form-item__error {
  color: #d0aa67;
  padding-top: 5px;
  position: relative;
  transition: 0.4s;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: #0061af;
}
.lead-form-container .el-form-item__content {
  font-size: 12px;
  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  line-height: 17px;
  margin-bottom: 18px;
}
.lead-form-container .el-form-item {
  margin-bottom: 0;
}
.el-button--primary:focus,
.el-button--primary:hover,
.el-button--primary.is-active,
.el-button--primary:active,
.el-button--primary {
  border-color: transparent;
}

.unique-overview .overview-right h3 {
  font-size: 34px;
  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  line-height: 40px;
}
.lead-form-container.success .success-msg {
  opacity: 1;
  pointer-events: all;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
	-moz-appearance: none;
  margin: 0;
}
.lead-form p {
  margin-bottom: 21px;
}
.lead-form-end {
  margin-top: auto;
}
.lead-form-end .btn {
  background: #0061af;
  min-width: 135px;
  padding: 0 20px;
  margin-left: 30px;
  align-self: flex-end;
}
.lead-form-end .btn span {
  font-size: inherit;
  font-family: inherit;
  color: inherit;
}
.lead-form-end .btn:hover {
  background: #d0aa67;
  color: #fff;
}
.close-popup {
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
.close-popup svg path {
  transition: 0.6s;
}
.close-popup:hover svg path {
  fill: #d0aa67;
}
.input-outer {
  overflow-y: auto;
  width: calc(100% + 15px);
  padding-right: 15px;
}
.input-outer::-webkit-scrollbar {
  width: 3px;
  background: #bcbec0;
}
.input-outer::-webkit-scrollbar-thumb {
  background: #444958;
}
.lead-form-popup .dynamicform {
  margin-top: 0;
}
.lead-form-popup .success {
  padding: 55px 30px 30px;
  background: #e2dfd8;
}
.form-end .btn {
  margin-left: 0;
}
@media (max-height: 850px) and (min-width: 768px) {
  .input-outer {
    max-height: 345px;
  }
}
@media (max-height: 680px) and (min-width: 768px) {
  .input-outer {
    max-height: 265px;
  }
}
@media (max-height: 590px) and (min-width: 768px) {
  .input-outer {
    max-height: 165px;
  }
}

@media (max-height: 800px) and (max-width: 767px) {
  .input-outer {
    max-height: 345px;
  }
}
@media (max-height: 680px) and (max-width: 767px) {
  .input-outer {
    max-height: 265px;
  }
}
@media (max-height: 590px) and (max-width: 767px) {
  .input-outer {
    max-height: 165px;
  }
}

@media (max-width: 767px) {
  .form-popup-content {
    width: calc(100% - 48px);
    padding: 20px;
    padding-right: 25px;
  }
  .lead-form-end {
    flex-direction: column;
    align-items: flex-start;
  }
  .lead-form-end .btn {
    align-self: flex-start;
    margin-left: 0;
    margin-top: 20px;
  }
  .form-end .btn span {
    font-size: 16px;
  }
  .reset-btn {
    height: 50px;
  }
}
</style>